import { render, staticRenderFns } from "./GoogleLoginIcon.vue?vue&type=template&id=1a333e6c"
import script from "./GoogleLoginIcon.vue?vue&type=script&lang=js"
export * from "./GoogleLoginIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports